// extracted by mini-css-extract-plugin
export default {"button":"SignUp_button__JapAW","logo":"SignUp_logo__+ySip"};